/*
 *  ButtonsOverview.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import logger from "../utils/LoggerFrontend";
import React from "react";
import Actions from "../Actions";

import BtnPrimary from "../Components/Btn__Primary.jsx";
import BtnSecondary from "../Components/Btn__Secondary.jsx";
import BtnTertiary from "../Components/Btn__Tertiary.jsx";

import ButtonPrimary from "../Components/ButtonPrimary";

import { Button as ButtonShared } from "@talentbait/shared-components";

import {
  ButtonPrimary as ButtonPrimarySelf,
  ButtonOutlined as ButtonPrimarySelfOutline
} from "./SelfServiceCampaignCreation/Previews/Components/Buttons.jsx";

import DraftButton from "../PagesUser/SelfServiceCampaignCreation/Previews/Components/DraftButton";
import BookButton from "../PagesUser/SelfServiceCampaignCreation/Previews/Components/BookButton";
import { THEME_SECONDARY } from "../PagesUser/SelfServiceCampaignCreation/Previews/Components/DraftButton/constants";

import * as sc from "../PagesUser/SelfServiceCampaignCreation/Coupon/styles";

const testNotif = (e) => {
  e.preventDefault();
  Actions.addNotification("Test");
};
//==============================================================================
// Internal dep.
//==============================================================================
export default class ButtonsOverview extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    logger.debug("ButtonsOverview:render", "called..", this.props);
    return (
      <div style={{ padding: 20 }}>
        <section>
          <h1 style={{ fontSize: 40 }}>Button Overview</h1>
          <div>
            <br />
            <br />
            <br />
            <br />
            <h2 style={{ fontSize: 20 }}>
              Primary & Secondary Buttons (TalentBait app / React comp)
            </h2>
            <div style={{ maxWidth: "50%" }}>
              <div className="flex">
                <BtnSecondary isLoading={false} onClick={testNotif}>
                  Secondary
                </BtnSecondary>
                <BtnPrimary isLoading={true} onClick={testNotif}>
                  Loading
                </BtnPrimary>
                <BtnPrimary isLoading={false} onClick={testNotif}>
                  Primary
                </BtnPrimary>
                <BtnPrimary isHighlight={true} onClick={testNotif}>
                  Highlight
                </BtnPrimary>
                <BtnTertiary onClick={testNotif}>Tertiary</BtnTertiary>
              </div>
              <br />
              <br />
              <br />
              <h2 style={{ fontSize: 20 }}>Primary Button Component (TalentBait app)</h2>
              <div className="flex">
                <ButtonPrimary onClick={testNotif} isLoading={false} disabled={false}>
                  Default
                </ButtonPrimary>
                <ButtonPrimary onClick={testNotif} isLoading={false} disabled={true}>
                  Disabled
                </ButtonPrimary>
                <ButtonPrimary onClick={testNotif} isLoading={true} disabled={true}>
                  Loading & Dis
                </ButtonPrimary>
              </div>
              <br />
              <br />

              <br />
              <br />
              <h2 style={{ fontSize: 20 }}>
                Buttons SelfServiceCampaignCreation (TalentBait app / Styled-comp)
              </h2>
              <div className="flex">
                <ButtonPrimarySelf onClick={testNotif} disabled={false}>
                  Jetzt aufladen
                </ButtonPrimarySelf>
                <ButtonPrimarySelfOutline onClick={testNotif} disabled={false}>
                  zurück (outline)
                </ButtonPrimarySelfOutline>
              </div>

              <br />
              <br />
              <h2 style={{ fontSize: 20 }}>
                Draft Button - SelfServiceCampaignCreation (TalentBait app / Styled-comp)
              </h2>
              <div className="flex">
                <DraftButton onClick={testNotif} disabled={false} theme={{}}>
                  Draft button
                </DraftButton>
                <DraftButton onClick={testNotif} disabled={true} theme={{}}>
                  Draft button
                </DraftButton>
                <DraftButton onSaveDraft={testNotif} disabled={false} theme={THEME_SECONDARY} />
              </div>
            </div>
            <h2 style={{ fontSize: 20 }}>
              Book Button - SelfServiceCampaignCreation (TalentBait app / Styled-comp)
            </h2>
            <div className="flex">
              <BookButton
                title={"Book button"}
                isLoading={false}
                onClick={testNotif}
                disabled={false}
              />
              <BookButton
                title={"Book button"}
                isLoading={true}
                onClick={testNotif}
                disabled={false}
              />
              <BookButton
                title={"Book now (disabled)"}
                isLoading={true}
                onClick={testNotif}
                disabled={true}
              />
              <BookButton
                title={"Book now (disabled)"}
                isLoading={false}
                onClick={testNotif}
                disabled={true}
              ></BookButton>
            </div>

            <h2 style={{ fontSize: 20 }}>Small buttons checkout (TalentBait app)</h2>
            <div className="flex">
              <sc.Button theme="apply" onClick={testNotif}>
                Anwenden
              </sc.Button>

              <sc.Button theme="remove" onClick={testNotif}>
                Anwenden
              </sc.Button>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <h2 style={{ fontSize: 20 }}>Button Overview (Shared components)</h2>
          <div>
            <div className="flex">
              <ButtonShared onClick={testNotif} size="xsmall" type="primary">
                xsmall
              </ButtonShared>
              <ButtonShared onClick={testNotif} size="small" type="primary">
                small
              </ButtonShared>
              <ButtonShared onClick={testNotif} size="medium" type="primary">
                medium
              </ButtonShared>
              <ButtonShared onClick={testNotif} size="large" type="primary">
                large
              </ButtonShared>
            </div>
            <br />
            <br />
            <br />
            <h2 style={{ fontSize: 20 }}>Button States (Shared components)</h2>
            <div className="flex">
              <ButtonShared onClick={testNotif} size="medium" type="primary" disabled>
                Disabled
              </ButtonShared>
              <ButtonShared onClick={testNotif} size="medium" type="primary">
                Hover
              </ButtonShared>
              <ButtonShared onClick={testNotif} size="medium" type="primary" active>
                Active
              </ButtonShared>

              <ButtonShared
                onClick={testNotif}
                uniqueStyle="applicant-topbar"
                autoWidth
                type="white"
              ></ButtonShared>
            </div>
            <br />
            <br />
            <br />
            <h1 style={{ fontSize: 20 }}>Button Types (Shared components)</h1>
            <div className="flex">
              <ButtonShared uniqueStyle="fit" active type="primary" onClick={testNotif}>
                Navy blue
              </ButtonShared>
              {/* <ButtonShared onClick={testNotif} size="medium" type="success">
                success
              </ButtonShared>
              <ButtonShared size="medium" type="info">
                info
              </ButtonShared>
              <ButtonShared size="medium" type="danger">
                danger
              </ButtonShared>
              <ButtonShared size="medium" type="warning">
                warning
              </ButtonShared>
              <ButtonShared size="medium" type="dark">
                dark
              </ButtonShared>
              <ButtonShared size="medium" type="white">
                white
              </ButtonShared>
              <ButtonShared size="medium" type="gray">
                gray
              </ButtonShared>
              <ButtonShared size="medium" type="none">
                none
              </ButtonShared> */}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
